// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/nordo-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/nordo-procedures/nordo-procedures.js';

mount([g0]);
